export default "__VITE_PUBLIC_ASSET__506600cc__"